import { render, staticRenderFns } from "./luckyDraw.vue?vue&type=template&id=1c4c5d36&scoped=true&"
import script from "./luckyDraw.vue?vue&type=script&lang=js&"
export * from "./luckyDraw.vue?vue&type=script&lang=js&"
import style0 from "./luckyDraw.vue?vue&type=style&index=0&id=1c4c5d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c5d36",
  null
  
)

export default component.exports